import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-retirement-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2377)">
        <path
          d="M4.36301 8.192C5.09367 6.59028 6.27714 5.23742 7.76748 4.30025C9.25782 3.36308 10.9899 2.88258 12.75 2.918C13.4961 2.92593 14.2388 3.02057 14.963 3.2L16.946 0.926C17.0494 0.839528 17.1743 0.78258 17.3074 0.761166C17.4405 0.739751 17.577 0.754663 17.7023 0.804329C17.8276 0.853996 17.9373 0.936574 18.0196 1.04335C18.1019 1.15013 18.1539 1.27715 18.17 1.411L18.526 4.882C19.8789 5.90871 20.8824 7.32744 21.4 8.945H23.25V14.973H20.76C20.2457 15.8914 19.5639 16.7055 18.75 17.373C17.8852 18.0895 16.8928 18.6361 15.825 18.984"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75 17.25C10.0637 17.25 12.75 15.9069 12.75 14.25C12.75 12.5931 10.0637 11.25 6.75 11.25C3.43629 11.25 0.75 12.5931 0.75 14.25C0.75 15.9069 3.43629 17.25 6.75 17.25Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.75 14.25V20.25C12.75 21.907 10.064 23.25 6.75 23.25C3.436 23.25 0.75 21.907 0.75 20.25V14.25"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 17.25C0.75 18.907 3.436 20.25 6.75 20.25C10.064 20.25 12.75 18.907 12.75 17.25"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.875 7.5C16.8008 7.5 16.7283 7.52199 16.6667 7.5632C16.605 7.6044 16.5569 7.66297 16.5285 7.73149C16.5002 7.80002 16.4927 7.87542 16.5072 7.94816C16.5217 8.0209 16.5574 8.08772 16.6098 8.14017C16.6623 8.19261 16.7291 8.22832 16.8018 8.24279C16.8746 8.25726 16.95 8.24984 17.0185 8.22145C17.087 8.19307 17.1456 8.14501 17.1868 8.08334C17.228 8.02167 17.25 7.94917 17.25 7.875C17.25 7.77554 17.2105 7.68016 17.1402 7.60984C17.0698 7.53951 16.9745 7.5 16.875 7.5Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.957 17.956L18.75 21"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2377">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessRetirementInsuranceIconComponent extends BaseIconComponent {}
